export const camelToTitle = string =>
  string
    .replace(/([A-Z]|[0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .replace(/\s+/g, ' ')

camelToTitle.description = `Transforms the provided camel-case string into seperate capitalized words.`

export default camelToTitle
